// removed by extract-text-webpack-plugin
module.exports = {"TypeFiltersWrap":"style__TypeFiltersWrap___3uctQ","Active":"style__Active___qIqql","TypeFiltersBtn":"style__TypeFiltersBtn___1tZ6f","Nedvex":"style__Nedvex___17Yo4","New":"style__New___31iId","Action":"style__Action___3GTCD","Popular":"style__Popular___2hs9V","Blacklist":"style__Blacklist___pK6aQ","TypeFiltersBtnLeft":"style__TypeFiltersBtnLeft___3UDKN","TypeFiltersBtnRight":"style__TypeFiltersBtnRight___1acGf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TypeFilters/style.scss
// module id = 1385
// module chunks = 0